import React, { Component } from 'react';
import { connect } from 'react-redux';

export default class YTplayer extends Component {
    render () {
        let config = '?enablejsapi=0;showinfo=0;playsinline=0;rel=0;' + (this.props.autoplay ? 'autoplay=1;' : 'autoplay=0;');
        let url = 'https://www.youtube.com/embed/' + this.props.ytId;
        return (
            <iframe frameBorder="0" allowFullScreen="1" src={url + config}/>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/YTplayer.js